import styles from './AiBadge.module.scss'

interface AiBadgeProps {
  className?: string
}

export const AiBadge: React.FC<AiBadgeProps> = ({ className }) => {
  return (
    <div className={`${styles.aiBadge} ${className || ''}`}>
      AI
    </div>
  )
} 